<template>
    <div class="EnableFulfillmentToggle">
        <span class="EnableFulfillmentToggle__container">
            <SwitchToggle
                :value="value"
                :disabled="disabled"
                hide-label
                v-bind="listenerAttrs"
            />
            Enable fulfillment
        </span>
    </div>
</template>

<style lang="scss">
    .EnableFulfillmentToggle {
        &__container {
            display: flex;
            align-items: center;

            .SwitchToggle {
                padding: 0;
                zoom: 0.9;
                margin-right: 15px;

                &--off .SwitchToggle__slider {
                    background-color: #778ea1;
                }

                &--on .SwitchToggle__slider {
                    background-color: #29b496;
                }
            }
        }
    }
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { SwitchToggle } from '@evidentid/dashboard-commons/components/SwitchToggle';
    import { pickListenerAttrs } from '@evidentid/vue-commons/utils/attrsListeners';

    export default defineComponent({
        name: 'EnableFulfillmentToggle',
        components: {
            SwitchToggle,
        },
        // PRODUCT-26110 Task 7: used as a JsonSchemaCustomFormElement `customComponentInput`
        // (see EmailContent.vue), which binds the full generic dynamic-form attribute set
        // (touched/required/deletable/rbac-disabled/show-validation-errors/...) via
        // `v-bind="$attrs"` -- none of those are declared props here, so without
        // `inheritAttrs: false` they fell through onto the root <div>, rendering e.g.
        // `touched="false"` in real DOM (an ATTR_FALSE_VALUE case, not a test-stub artifact).
        // None of those generic attrs are meaningful for this toggle, so drop them entirely.
        inheritAttrs: false,
        props: {
            value: {
                type: Boolean,
            },
            disabled: {
                type: Boolean,
            },
        },
        computed: {
            // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): keep forwarding listeners only
            // (never the generic dynamic-form attrs this component deliberately drops,
            // per the comment above) -- Vue 3 merges listeners into `$attrs`, so pick
            // just the `onXxx` keys back out instead of a blanket `v-bind="$attrs"`.
            listenerAttrs(): Record<string, unknown> {
                return pickListenerAttrs(this.$attrs);
            },
        },
    });
</script>
